import styled from 'styled-components';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import NavLink from '../../common/NavLink';
import { mixins, fonts, media } from '../../../../css';

export const StyledExpansionPanel = styled(Accordion)`
  && {
    box-shadow: none;
    margin: 0;
    ${({ theme }) => `background-color: ${theme.darkTheme}`};

    &:before {
      height: 0;
      background-color: transparent;
    }
    [class^='MuiButtonBase-root'] {
      &:hover {
        ${({ theme }) => `background-color: ${theme.darkerTheme}`};
        div {
          ${({ theme }) => `color: ${theme.lightTheme}`};
        }
      }
    }
    &.curRoute {
      [class^='MuiButtonBase-root'] {
        &:hover {
          ${({ theme }) => `background-color: ${theme.midTheme}`};
        }
      }
    }
  }
`;

export const StyledExpansionPanelSummary = styled(AccordionSummary)`
  &&& {
    height: ${mixins.pxToRem(54)};
    min-height: ${mixins.pxToRem(54)};
    &.curRoute {
      ${({ theme }) => `background-color: ${theme.mainTheme}`};
    }

    &:hover {
      &.curRoute {
        ${({ theme }) => `background-color: ${theme.midTheme}`};
      }
    }
  }
`;

export const StyledExpansionPanelDetails = styled(AccordionDetails)`
  && {
    padding: ${mixins.pxToRem(0)};
    padding-left: ${mixins.pxToRem(54)};
    ${({ theme }) => `background-color: ${theme.darkerTheme}`};
    a {
      &:hover {
        ${({ theme }) => `background-color: ${theme.darkestTheme}`};
        &.curRoute {
          ${({ theme }) => `background-color: ${theme.midTheme}`};
        }
      }
    }
  }
`;

export const StyledNav = styled.div`
  cursor: pointer;
  font-size: ${mixins.pxToRem(14)};
  ${({ theme }) => `color: ${theme.lightText}`};
  font-family: ${fonts.fontRegular};
  text-decoration: none;
  display: flex;
  align-items: center;

  .label {
    margin-left: ${mixins.pxToRem(20)};
  }
  ${media.greaterThan('lg')`flex-flow: row nowrap; align-items: center; justify-items: center; height: 100%;`};
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  min-height: ${mixins.pxToRem(54)};

  .label {
    margin-left: ${mixins.pxToRem(20)};
  }

  &.curRoute {
    ${({ theme }) => `background-color: ${theme.mainTheme}`};
  }

  &:hover {
    ${({ theme }) => `color: ${theme.lightTheme}`};
    ${({ theme }) => `background-color: ${theme.darkerTheme}`};
    &.curRoute {
      ${({ theme }) => `background-color: ${theme.midTheme}`};
    }
  }
`;

export const HelpSupport = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  flex-direction: column;
  padding: ${mixins.pxToRem(10)} 0;
  min-height: ${mixins.pxToRem(54)};
`;

export const RouteRect = styled.div`
  position: absolute;
  height: ${mixins.pxToRem(40)};
  width: ${mixins.pxToRem(7)};
  ${({ theme }) => `background-color: ${theme.lightTheme}`};
  left: 0;
`;
